var config = {
  isShopify: true,
  shopifyShopId: "blank-shopify-id",
  customerId: "",
  whatsappPhoneNumberId: "",
  whatsappToken: "",
  klaviyoToken: "",
  apiKeyGorgias: "",
  phoneNumber: "",
  unreadConversations: 0,
  emails: "",
  scheduledCampaignCount: 0,
  isGaiaActivated: false,
};

export { config };
